import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import SeveralBrandsWrapper from "@components/layouts/severalBrandsWrapper";
import ClinicalTrialsContainer from "@components/severalbrands/clinicalTrialsComponents";
import GeneralContainer from "@components/severalbrands/generalComponents";
import DebtReliefContainer from "@components/severalbrands/debtReliefComponents";
import HighEndRehabContainer from "@components/severalbrands/highEndRehabComponents";
import { DomainInfo } from "@components/severalbrands/utils/services";
import TortsContainer from "@components/severalbrands/tortsComponents";

const generalCategorySlugs = [
    "sb-clinical-trials",
    "clinical-trials",
    "torts",
    "sb-debt-relief",
    "debt-relief",
    "sb-high-end-rehab",
    "high-end-rehab",
    "general",
];

export default function SeveralBrandsCategoryPage(): ReactElement {
    const { domain, category } = useDomainContext();
    let content;
    switch (category?.slug) {
        case "sb-clinical-trials":
        case "clinical-trials":
            content = <ClinicalTrialsContainer />;
            break;
        case "torts":
            content = <TortsContainer />;
            break;
        case "sb-debt-relief":
        case "debt-relief":
            content = <DebtReliefContainer />;
            break;
        case "sb-high-end-rehab":
        case "high-end-rehab":
            content = <HighEndRehabContainer />;
            break;
        case "general":
            content = <GeneralContainer />;
            break;
    }
    return (
        <SeveralBrandsWrapper domainInfo={domain as DomainInfo}>
            {content}
        </SeveralBrandsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const result = await getPageProps(context, "category");
    if (
        "props" in result &&
        !generalCategorySlugs.includes(
            ((result.props as { category?: { slug?: string } }).category
                ?.slug as string) ?? "",
        )
    ) {
        return { notFound: true };
    }
    return result;
};
